import type { Ticket } from '../types/support';

export const tickets: Ticket[] = [
  {
    id: 'tk-1',
    ref: 'SUP-4471',
    subject: 'Grocery receipt looks higher than the estimate',
    category: 'payment',
    status: 'awaiting_you',
    createdAt: '2026-08-30T10:00:00.000Z',
    updatedAt: '2026-09-02T11:20:00.000Z',
    bookingRef: 'PA-1001',
    messages: [
      {
        id: 'tm-1',
        from: 'you',
        author: 'Dao Wattana',
        body: 'The grocery total on PA-1001 came in ฿1,400 above what we discussed. Not a complaint about the food — just want to understand the line.',
        at: '2026-08-30T10:00:00.000Z',
      },
      {
        id: 'tm-2',
        from: 'support',
        author: 'Noor from Pan & Apron',
        body: 'Thanks Dao — I can see two receipts attached, and one is the separate shellfish-free wok oil and crab substitute, which is roughly the difference. Would you like me to ask Ploy to split that line out so it is visible next time?',
        at: '2026-09-02T11:20:00.000Z',
      },
    ],
  },
  {
    id: 'tk-2',
    ref: 'SUP-4402',
    subject: 'Allergy note did not appear on the printed quote',
    category: 'safety',
    status: 'resolved',
    createdAt: '2026-07-14T15:30:00.000Z',
    updatedAt: '2026-07-16T09:05:00.000Z',
    bookingRef: 'PA-0987',
    messages: [
      {
        id: 'tm-3',
        from: 'you',
        author: 'Dao Wattana',
        body: 'My shellfish allergy showed in the chat but not on the quote PDF I forwarded to my family. Can that be fixed?',
        at: '2026-07-14T15:30:00.000Z',
      },
      {
        id: 'tm-4',
        from: 'support',
        author: 'Noor from Pan & Apron',
        body: 'It is fixed — allergy records now print on every quote and every chef has to acknowledge them before sending. Thank you for flagging it, this was the right catch.',
        at: '2026-07-16T09:05:00.000Z',
      },
    ],
  },
  {
    id: 'tk-3',
    ref: 'SUP-4530',
    subject: 'How do payouts work for at-cost groceries?',
    category: 'payment',
    status: 'open',
    createdAt: '2026-09-01T08:40:00.000Z',
    updatedAt: '2026-09-01T08:40:00.000Z',
    messages: [
      {
        id: 'tm-5',
        from: 'you',
        author: 'Dao Wattana',
        body: 'If a chef bills groceries at cost, when is that charged — with the deposit or with the balance?',
        at: '2026-09-01T08:40:00.000Z',
      },
    ],
  },
];

export const supportTopics = [
  { id: 'booking', label: 'A booking or quote', detail: 'Dates, changes, cancellations, no-shows' },
  { id: 'payment', label: 'Payments & payouts', detail: 'Deposits, balances, receipts, refunds' },
  { id: 'safety', label: 'Safety or allergies', detail: 'Anything about food safety or an allergen' },
  { id: 'account', label: 'My account', detail: 'Profile, verification, notifications' },
  { id: 'other', label: 'Something else', detail: 'We read all of these' },
] as const;
